export class RecaptchaException extends Error {
  constructor () {
    super('recaptcha-failed')
  }
}
